import { render, staticRenderFns } from "./requisiteArchiveTop.vue?vue&type=template&id=2bc4f999&scoped=true"
import script from "./requisiteArchiveTop.vue?vue&type=script&lang=js"
export * from "./requisiteArchiveTop.vue?vue&type=script&lang=js"
import style0 from "./requisiteArchiveTop.vue?vue&type=style&index=0&id=2bc4f999&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4f999",
  null
  
)

export default component.exports